'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = require('react-i18next');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRouter = require('react-router');

var _projects = require('helpers/projects');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./QuickSendBoxTabs.scss');

var QuickSendBoxTabs = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(QuickSendBoxTabs, _Component);

  function QuickSendBoxTabs() {
    (0, _classCallCheck3.default)(this, QuickSendBoxTabs);
    return (0, _possibleConstructorReturn3.default)(this, (QuickSendBoxTabs.__proto__ || (0, _getPrototypeOf2.default)(QuickSendBoxTabs)).apply(this, arguments));
  }

  (0, _createClass3.default)(QuickSendBoxTabs, [{
    key: 'renderTab',
    value: function renderTab(type, title) {
      var active = this.props.active;


      return _react2.default.createElement(
        _reactRouter.Link,
        { className: (0, _classnames2.default)(styles.tab, styles.switch, (0, _defineProperty3.default)({}, styles.active, active === type)), to: '/quick-send/' + type },
        _react2.default.createElement(
          'span',
          { className: styles.title },
          title
        ),
        _react2.default.createElement(
          'svg',
          { viewBox: '0 0 49 40', id: 'svg4138', version: '1.1' },
          _react2.default.createElement(
            'g',
            { id: 'layer1' },
            _react2.default.createElement('path', {
              d: 'M 0,0 C 11,0 14,3 19,11 c 5,8.5 3.5,6 6,10 2.5,3.5 3.5,6 6.5,10 5,5.5 9,8 18.5,9 L 0,40 Z',
              id: 'path6174'
            })
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;


      return _react2.default.createElement(
        'div',
        { className: styles.tabs },
        this.renderTab(_projects.quickSendBox.inbox, t('Inbox')),
        this.renderTab(_projects.quickSendBox.sent, t('Sent')),
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)(styles.tab, styles.addTab) },
          _react2.default.createElement(
            _reactRouter.Link,
            { className: 'btn btn-accent squared small', to: '/quick-send/new' },
            _react2.default.createElement('i', { className: 'icon-add-box' }),
            t('Create New')
          )
        )
      );
    }
  }]);
  return QuickSendBoxTabs;
}(_react.Component), _class2.propTypes = {
  active: _propTypes2.default.string,
  t: _propTypes2.default.func
}, _temp)) || _class);
exports.default = QuickSendBoxTabs;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/QuickSend/QuickSendBoxTabs.js
// module id = 2071
// module chunks = 1